import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { updateMaterialLayoutNesting } from "#modules/materialLayouts/infra/updateMaterialLayoutNesting.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const useUpdateMaterialLayoutNesting = ({
  quoteRequestLineId,
  options,
}: {
  quoteRequestLineId: string | undefined;
  options?: {
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onMutate?: () => void;
  };
}) => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, ...rest } = useMutation({
    mutationFn: updateMaterialLayoutNesting,
    onMutate: () => {
      options?.onMutate?.();
    },
    onSuccess: (_data) => {
      if (quoteRequestLineId) {
        void queryClient.invalidateQueries({
          queryKey: queryKeys.quoteRequestLines.detail(quoteRequestLineId),
        });
      }

      options?.onSuccess?.();
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      options?.onError?.(err);
    },
  });

  return {
    updateMaterialLayoutNesting: mutate,
    updateMaterialLayoutAsync: mutateAsync,
    ...rest,
  };
};
